import { render, staticRenderFns } from "./OrderBook.vue?vue&type=template&id=2b329448&scoped=true"
import script from "./OrderBook.vue?vue&type=script&lang=js"
export * from "./OrderBook.vue?vue&type=script&lang=js"
import style0 from "./OrderBook.vue?vue&type=style&index=0&id=2b329448&prod&lang=scss"
import style1 from "./OrderBook.vue?vue&type=style&index=1&id=2b329448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b329448",
  null
  
)

export default component.exports